export default {
  /**
   * USAIL Security Plugin
   * @param Vue
   * @param options {{router: Object}, {callbackComponent: Object}, {allowedOrganizationRoles: Array}, {allowedVesselRoles: Array}}
   * @returns {*|boolean|[]|void|boolean}
   */
  install(Vue, options = {}) {
    options.router.addRoute({
      name: 'authCallback',
      path: '/auth-callback',
      component:
        'callbackComponent' in options ? options.callbackComponent : () => import('../../views/AuthCallback.vue')
    })

    options.router.addRoute({
      name: 'logout',
      path: '/logout',
      beforeEnter: () => {
        Vue.usailSecurity.removeUser()
        Vue.keycloak.logout()
      }
    })

    Vue.prototype.$usailSecurity = {
      routeGuard(to, from, next) {
        if (!this.getUser() || !Vue.keycloak.authenticated || Vue.keycloak.tokenParsed.sub !== this.getUser().sub) {
          localStorage.setItem('callbackUrl', window.location.pathname)
          Vue.keycloak.login({
            redirectUri: window.origin + '/auth-callback'
          })
        }
        next()
      },

      getUser() {
        return JSON.parse(localStorage.getItem('user'))
      },

      setUser(user) {
        return localStorage.setItem('user', JSON.stringify(user))
      },

      removeUser() {
        return localStorage.removeItem('user')
      },

      isGranted(resource, role) {
        const user = JSON.parse(localStorage.getItem('user'))

        const resourceId = typeof resource === 'string' ? resource : resource['@id']

        if (resourceId.includes('/organizations/')) {
          for (let x in user.roleInOrganizations) {
            let roleInOrganization = user.roleInOrganizations[x]
            if (
              roleInOrganization.organization['@id'] === resourceId &&
              roleInOrganization.organizationRole.name === role
            ) {
              return true
            }
          }
          return false
        } else if (resourceId.includes('/vessels/')) {
          for (let x in user.roleInVessels) {
            let roleInVessel = user.roleInVessels[x]
            if (roleInVessel.vessel['@id'] === resourceId && roleInVessel.vesselRole.name === role) {
              return true
            }
          }
          return false
        }
      },

      getUserVessels() {
        const user = this.getUser()
        let vessels = []

        for (let i in user.roleInVessels) {
          let roleInVessel = user.roleInVessels[i]

          if (!vessels.includes(roleInVessel.vessel)) {
            vessels.push(roleInVessel.vessel)
          }
        }

        return vessels
      },

      getUserOrganizations() {
        const user = this.getUser()
        let organizations = []

        for (let i in user.roleInOrganizations) {
          let roleInOrganization = user.roleInOrganizations[i]

          if (!organizations.includes(roleInOrganization.organization)) {
            organizations.push(roleInOrganization.organization)
          }
        }

        return organizations
      },

      hasRoleInOrganizations(rolesToCheck) {
        const user = this.getUser()
        let hasRole = false

        if (!user.roleInOrganizations) {
          return hasRole
        }

        user.roleInOrganizations.forEach(roleInOrganization => {
          if (rolesToCheck.includes(roleInOrganization.organizationRole.name)) {
            hasRole = true
          }
        })

        return hasRole
      },

      hasRoleInVessels(rolesToCheck) {
        const user = this.getUser()
        let hasRole = false

        if (!user.roleInVessels) {
          return hasRole
        }

        user.roleInVessels.forEach(roleInVessel => {
          if (rolesToCheck.includes(roleInVessel.vesselRole.name)) {
            hasRole = true
          }
        })

        return hasRole
      },

      isAllowed() {
        return (
          this.hasRoleInOrganizations(options.allowedOrganizationRoles) ||
          this.hasRoleInVessels(options.allowedVesselRoles)
        )
      },

      hasReachableRole(role) {
        const user = this.getUser()

        if (!user || !('reachableRoles' in user) || !user.reachableRoles) {
          return false
        }

        return user.reachableRoles.includes(role)
      }
    }
    Vue.usailSecurity = Vue.prototype.$usailSecurity
  }
}
